import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  query,
  where,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase"; // Import your Firebase configuration
import { Modal, Button, Form, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FacilityTable.css";

const FacilityTable = () => {
  const facilityTypes = ["Toilet", "Rest", "Other"];
  const [facilities, setFacilities] = useState([]);
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const merchantId = currentUser ? currentUser.uid : null;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [facilityToDelete, setFacilityToDelete] = useState(null);
  const [facilityNameToDelete, setFacilityNameToDelete] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [facilityToEdit, setFacilityToEdit] = useState(null);
  const [editedFacilityName, setEditedFacilityName] = useState("");
  const [editedFacilityLocation, setEditedFacilityLocation] = useState("");
  const [editedFacilityType, setEditedFacilityType] = useState("");
  const [editedFacilityDescription, setEditedFacilityDescription] =
    useState("");
  const [editedCustomDescription, setEditedCustomDescription] = useState("");
  const [inputError, setInputError] = useState("");
  const [isCustomDescription, setIsCustomDescription] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedFacilityDetails, setSelectedFacilityDetails] = useState(null);
  const [shownDescription, setShownDescription] = useState("");

  //paging
  const facilitiesPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastFacility = currentPage * facilitiesPerPage;
  const indexOfFirstFacility = indexOfLastFacility - facilitiesPerPage;
  const facilitiesToShow= facilities.slice(
    indexOfFirstFacility,
    indexOfLastFacility
  );
  const totalPages = Math.ceil(facilities.length / facilitiesPerPage);
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };


  let unsubscribe;

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        if (merchantId) {
          const q = query(
            collection(db, "facility"),
            where("merchant_id", "==", merchantId)
          );
          const querySnapshot = await getDocs(q);
          const data = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setFacilities(data);

          // Set up a real-time listener for changes
          unsubscribe = onSnapshot(q, (snapshot) => {
            const updatedData = snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setFacilities(updatedData);
          });
        }
      } catch (error) {
        console.error("Error fetching facilities: ", error);
      }
    };

    fetchFacilities();

    return () => {
      // Unsubscribe from the listener when component unmounts
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [merchantId]);

  const handleDelete = async (id, name) => {
    // Show confirmation dialog
    setFacilityNameToDelete(name);
    setFacilityToDelete(id);
    setShowConfirmation(true);
  };

  const showFacilityDetails = (facility) => {
    setSelectedFacilityDetails(facility);
    setShowModal(true);
    setShownDescription("")
    let tempDes=""
    if(facility.isCustomDescription){
      facility.description.forEach(element => {
        if(element!== 'Others'){
          tempDes = tempDes +element +', '
        }
      });
      tempDes += facility.customDescription
    }else{
      facility.description.forEach(element => {
          tempDes = tempDes +element +', '
      });
      tempDes = tempDes.substring(0, tempDes.length-2)
    }
    setShownDescription(tempDes)
  };

  const confirmDelete = async () => {
    try {
      await deleteDoc(doc(db, "facility", facilityToDelete));
      const updatedFacilities = facilities.filter(
        (facility) => facility.id !== facilityToDelete
      );
      console.log('Delete Facility', facilityToDelete)
      setFacilities(updatedFacilities);
      setShowConfirmation(false); // Close confirmation dialog after delete
    } catch (error) {
      console.error("Error deleting facility: ", error);
    }
  };

  const handleEdit = (facility) => {
    setError("");
    setFacilityToEdit(facility);
    setEditedFacilityName(facility.facilityName);
    setEditedFacilityLocation(facility.location);
    setEditedFacilityType(facility.type);
    setEditedFacilityDescription(facility.description || ""); // Set default description if available
    setEditedCustomDescription(facility.customDescription);
    setIsCustomDescription(facility.isCustomDescription);
    setShowEditModal(true);
  };

  const handleEditConfirmation = async () => {
    if (
      (!editedFacilityName || editedFacilityName.trim() === "") &&
      (!editedFacilityDescription || editedFacilityDescription.length === 0)
    ) {
      return setError(
        "Facility Name and Facility description should not be empty"
      );
    }

    if (!editedFacilityName || editedFacilityName.trim() === "") {
      return setError("Facility Name should not be empty");
    }

    if (!editedFacilityDescription || editedFacilityDescription.length === 0) {
      return setError("Facility description should not be empty");
    }

    if (isCustomDescription && !editedCustomDescription) {
      return setError("Custom description should not be empty");
    }
    try {
    } catch (error) {
      alert("Error in editing the facility, please try again.");
    }
    console.log("Edited Facility Details:", {
      id: facilityToEdit.id,
      editedFacilityName,
      editedFacilityLocation,
      editedFacilityType,
      editedFacilityDescription,
      editedCustomDescription,
      isCustomDescription,
    });
    const facilityRef = doc(db, "facility", facilityToEdit.id);

    // Set the "capital" field of the city 'DC'
    await updateDoc(facilityRef, {
      facilityName: editedFacilityName,
      location: editedFacilityLocation,
      type: editedFacilityType,
      description: editedFacilityDescription,
      customDescription: editedCustomDescription,
      isCustomDescription: isCustomDescription,
    });

    setShowEditModal(false); // Close the edit modal after editing
  };

  const handleCheckboxChange = (option, e) => {
    let updatedDescriptions;
    if (option === "Others") {
      updatedDescriptions = e.target.checked
        ? [...editedFacilityDescription, "Others"]
        : editedFacilityDescription.filter((desc) => desc !== "Others");
      if (!e.target.checked) {
        setEditedCustomDescription("");
        setIsCustomDescription(false);
      } else {
        setIsCustomDescription(true);
      }
    } else {
      updatedDescriptions = e.target.checked
        ? [...editedFacilityDescription, option]
        : editedFacilityDescription.filter((desc) => desc !== option);
    }
    setEditedFacilityDescription(updatedDescriptions);
  };

  return (
    <div className="table-responsive mx-5 my-1 mt-3 mt-sm-2">
      <table className="table">
        <thead>
          <tr className="custom-trow">
            <th className="custom-thead">Facility</th>
            <th className="custom-thead">Type</th>
            <th className="custom-thead">Rating</th>
            <th className="custom-thead">Action</th>
            <th className="custom-thead"></th>
          </tr>
        </thead>
        <tbody>
          {facilitiesToShow && facilitiesToShow.map((facility) => (
            <tr className="custom-trow" key={facility.id}>
              <td data-label="Facility">{facility.facilityName}</td>
              <td data-label="Type">{facility.type}</td>
              <td data-label="Rating">{facility.rating.toFixed(2)}</td>
              <td data-label="Action">
                <i
                  className="bi bi-pencil-fill edit-icon mx-2 fs-4"
                  onClick={() => handleEdit(facility)}
                ></i>
                <i
                  className="bi bi-trash-fill trash-icon mx-2 fs-4"
                  onClick={() =>
                    handleDelete(facility.id, facility.facilityName)
                  }
                ></i>
              </td>
              <td><Button className="custom-button" onClick={() => showFacilityDetails(facility)}>View</Button></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-end align-items-center mt-3">
          <div className="justify-content-center">
            <h6 className="me-3" style={{ color: "grey", fontSize: "15px" }}>
              {currentPage} of {totalPages > 0 ? totalPages : 1} pages
            </h6>
          </div>
          <button
            className="btn custom-button me-2"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="btn custom-button "
            onClick={nextPage}
            disabled={currentPage === totalPages || totalPages==0}
          >
            Next
          </button>
        </div>
      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
          <i className="bi bi-trash-fill fs-4 me-2"></i>
          <Modal.Title className="fs-4">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-4 d-flex flex-column align-items-center justify-content-center">
          Are you sure to delete facility:{" "}
          <p className="name">{facilityNameToDelete}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between mt-4">
          <Button id="confirm-button" onClick={confirmDelete}>
            Confirm
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
            className="cancel-button"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <i className="bi bi-pencil-fill fs-4 me-2"></i>
          <Modal.Title>Edit Facility</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="editedFacilityName">
              <Form.Label>
                Facility Name <span className="req">*</span>
                {inputError && <span className="req-input">{inputError}</span>}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                value={editedFacilityName}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue.length <= 50) {
                    setEditedFacilityName(inputValue);
                    setInputError("");
                  } else {
                    setEditedFacilityName(inputValue.slice(0, 50));
                    setInputError("should not longer than 50 character");
                  }
                }}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="editedFacilityLocation">
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="eg: first floor"
                value={editedFacilityLocation}
                onChange={(e) => setEditedFacilityLocation(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="facilityTypes">
              <Form.Label>
                Type <span className="req">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                value={editedFacilityType}
                onChange={(e) => {
                  setEditedFacilityType(e.target.value);
                  setEditedFacilityDescription([]); // Reset description when type changes
                  setEditedCustomDescription("");
                  setIsCustomDescription(false);
                }}
              >
                {facilityTypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group
              className="mb-3"
              controlId="editededitedFacilityDescription"
            >
              <Form.Label>
                Description <span className="req">*</span>
              </Form.Label>
              {editedFacilityType === "Toilet" && (
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Male Toilet"
                    checked={editedFacilityDescription.includes("Male Toilet")}
                    onChange={(e) => handleCheckboxChange("Male Toilet", e)}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Female Toilet"
                    checked={editedFacilityDescription.includes(
                      "Female Toilet"
                    )}
                    onChange={(e) => handleCheckboxChange("Female Toilet", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Family Toilet"
                    checked={editedFacilityDescription.includes(
                      "Family Toilet"
                    )}
                    onChange={(e) => handleCheckboxChange("Family Toilet", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="OKU Toilet"
                    checked={editedFacilityDescription.includes("OKU Toilet")}
                    onChange={(e) => handleCheckboxChange("OKU Toilet", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Others"
                    checked={editedFacilityDescription.includes("Others")}
                    onChange={(e) => handleCheckboxChange("Others", e)}
                  />
                  {editedFacilityDescription.includes("Others") && (
                    <Form.Control
                      type="text"
                      placeholder="Enter description"
                      value={editedCustomDescription}
                      onChange={(e) =>
                        setEditedCustomDescription(e.target.value)
                      }
                      required
                    />
                  )}
                </div>
              )}

              {editedFacilityType === "Rest" && (
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Seating Area"
                    checked={editedFacilityDescription.includes("Seating Area")}
                    onChange={(e) => handleCheckboxChange("Seating Area", e)}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Restrooms"
                    checked={editedFacilityDescription.includes("Restrooms")}
                    onChange={(e) => handleCheckboxChange("Restrooms", e)}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Pet-Friendly Zone"
                    checked={editedFacilityDescription.includes(
                      "Pet-Friendly Zone"
                    )}
                    onChange={(e) =>
                      handleCheckboxChange("Pet-Friendly Zone", e)
                    }
                  />

                  <Form.Check
                    type="checkbox"
                    label="Tables and Chairs"
                    checked={editedFacilityDescription.includes(
                      "Tables and Chairs"
                    )}
                    onChange={(e) =>
                      handleCheckboxChange("Tables and Chairs", e)
                    }
                  />

                  <Form.Check
                    type="checkbox"
                    label="Others"
                    checked={editedFacilityDescription.includes("Others")}
                    onChange={(e) => handleCheckboxChange("Others", e)}
                  />
                  {editedFacilityDescription.includes("Others") && (
                    <Form.Control
                      type="text"
                      placeholder="Enter description"
                      value={editedCustomDescription}
                      onChange={(e) =>
                        setEditedCustomDescription(e.target.value)
                      }
                      required
                    />
                  )}
                </div>
              )}

              {editedFacilityType === "Other" && (
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Others"
                    checked={editedFacilityDescription.includes("Others")}
                    onChange={(e) => handleCheckboxChange("Others", e)}
                  />
                  {editedFacilityDescription.includes("Others") && (
                    <Form.Control
                      type="text"
                      placeholder="Enter description"
                      value={editedCustomDescription}
                      onChange={(e) =>
                        setEditedCustomDescription(e.target.value)
                      }
                      required
                    />
                  )}
                </div>
              )}
            </Form.Group>
            {error && <Alert variant="danger mt-2">{error}</Alert>}

            <Modal.Footer className="d-flex justify-content-between mt-4">
              <Button
                className="custom-button"
                onClick={handleEditConfirmation}
              >
                Confirm
              </Button>
              <Button
                variant="secondary"
                onClick={() => setShowEditModal(false)}
                className="cancel-button"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Facility Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedFacilityDetails && (
            <div>
              <p><strong>Name</strong>: {selectedFacilityDetails.facilityName}</p>
              <p><strong>Type</strong>: {selectedFacilityDetails.type}</p>
              <p><strong>Rating</strong>: {selectedFacilityDetails.rating.toFixed(2)}</p>
              <p><strong>Location</strong>: {selectedFacilityDetails.location}</p>
              <p><strong>Description</strong>: {shownDescription && shownDescription}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="custom-button" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FacilityTable;
